import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, Spinner } from "@fluentui/react-components";
import { useTranslation } from 'react-i18next';
import { CheckmarkFilled } from "@fluentui/react-icons/lib/icons/chunk-1";

export type appearance = "primary" | "secondary" | "outline" | "subtle" | "transparent" | undefined;
export type shape = "circular" | "square" | undefined;

type Props = {
    onDismiss: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    buttonApparence: appearance;
    buttonShape: shape;
    buttonTitle: string;
    buttonIcon?: React.ReactElement;
    isProcessing?: boolean;
}


export const ConfirmationModalComponent = (props: Props) => {
    const { t } = useTranslation();

    //events
    const handleDismiss = () => {
        props.onDismiss();
    };

    const handleConfirm = () => {
        props.onConfirm();
    };

    const buttonIcon = props.isProcessing ? (
      <Spinner size="tiny" />
    ) : props.buttonIcon;

    return (
        <Dialog>
            <DialogTrigger disableButtonEnhancement>
                <Button shape={props.buttonShape} icon={buttonIcon} appearance={props.buttonApparence}>{props.buttonTitle}</Button>
            </DialogTrigger>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>{props.title}</DialogTitle>
                    <DialogContent>
                        {props.message}
                    </DialogContent>
                    <DialogActions>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="primary" onClick={handleConfirm}>{t('commons.confirmationModal.confirm', 'Confirmar')}</Button>
                        </DialogTrigger>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="secondary" onClick={handleDismiss}>{t('commons.confirmationModal.cancel', 'Cancelar')}</Button>
                        </DialogTrigger>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
}

export default ConfirmationModalComponent;